import { FC } from 'react'

import { PaginationWrapper, ItemsCounter, StyledPagination } from './styled'

interface ListPaginationProps {
  current: number
  total: number
  pageSize?: number
  itemName?: string
  onChange?: (page: number, pageSize: number) => void
  showSizeChanger?: boolean
  showLessItems?: boolean
}

const DEFAULT_PAGE_SIZE = 20

export const ListPagination: FC<ListPaginationProps> = ({
  current,
  total,
  pageSize = DEFAULT_PAGE_SIZE,
  itemName = 'items',
  onChange,
  showSizeChanger = false,
  showLessItems = true,
}) => {
  const startItem = (current - 1) * pageSize + 1
  const endItem = Math.min(current * pageSize, total)

  return (
    <PaginationWrapper>
      <ItemsCounter>
        <span>
          {startItem} - {endItem}
        </span>
        <span>of</span>
        <span>{total}</span>
        <span>{itemName}</span>
      </ItemsCounter>
      <StyledPagination
        current={current}
        total={total}
        showLessItems={showLessItems}
        pageSize={pageSize}
        onChange={onChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={false}
      />
    </PaginationWrapper>
  )
}
